import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAddFavoriteMovie } from "../../models/IAddFavoriteMovie";
import { IMovies } from "../../models/IMovies";

export const favoritesApi = createApi({
  reducerPath: "favoritesApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://cinemaguide.skillbox.cc" }),
  tagTypes: ["Favorites"],
  endpoints: (build) => ({
    addFavorites: build.mutation<IAddFavoriteMovie, IAddFavoriteMovie>({
      query: (id) => ({
        url: `/favorites`,
        method: "POST",
        body: id,
        credentials: "include",
      }),
      invalidatesTags: ["Favorites"],
    }),
    delFavorites: build.mutation<string, string>({
      query: (id) => ({
        url: `/favorites/${id}`,
        method: "DELETE",
        credentials: "include",
      }),
      invalidatesTags: ["Favorites"],
    }),
    getFavorites: build.query<IMovies[], string>({
      query: (url) => ({
        url: url,
        credentials: "include",
      }),
      providesTags: ["Favorites"],
    }),
  }),
});
